export default __webpack_public_path__ + "static/media/nigeria.226157bc.png";